import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { resetBlock, closePopup, setReuse, setIntervalId } from './bitPaymentSlice';
import PopUp from '../Popup/PopUp';
import BitPaymentWrapper from './BitPaymentWrapper';
import CancelPaymentPopupComponent from './Popups/CancelPaymentPopupComponent';
import { isMobile } from 'react-device-detect';

import './bitPayment.scss';

const BitPaymentComponent = (props) => {
  useEffect(() => {
    if (props.bitReturnEvent) {
      props.actionOnPaymentCompleted();
    }
    return () => {
    };
  }, []);

  useEffect(() => {
    if (props.bit.intervalId) {
      clearInterval(props.bit.intervalId); // Clear the interval on unmount
    }
  }, [props.bit.externalSystemReference]);


  function getActivePaymentStatus() {
    if (isMobile) {
      // Set interval to execute the function every 15 seconds
      const intervalId = setInterval(props.actionOnPaymentPending, 15000); // 15000 milliseconds = 15 seconds
      props.setIntervalId(intervalId)
    }
  }
  return (
    <div className='bit-payment'>
      {!isMobile && (
        <PopUp showPopUp={props.bit.showPopup} onClose={props.closePopup} className='cancel-bit-payment'>
          <CancelPaymentPopupComponent setReuse={props.setReuse} closePopup={props.closePopup} />
        </PopUp>
      )}
      {(props.bit.isReady || props.bit.reuse) && (
        <BitPaymentWrapper
          actionOnPaymentCompleted={props.actionOnPaymentCompleted}
          ban={props.ban} paymentAmount={props.paymentAmount}
          getActivePaymentStatus={getActivePaymentStatus}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bit: state.bitPayment,
  };
};

const mapDispatchToProps = { resetBlock, closePopup, setReuse, setIntervalId };

export default connect(mapStateToProps, mapDispatchToProps)(BitPaymentComponent);
